import {LazyImages} from "./modules/lazyImages";
import Swiper from 'swiper/swiper-bundle';
import Menu from "./modules/menu";
import * as $ from 'jquery';
import {FormValidation} from "./modules/FormValidation";

const $window = $(window);
const $body = $('body');

new LazyImages($body);
new Menu();
require('lity');

let maps = document.getElementsByClassName('block__map');

if (maps.length) {
    for (let i = 0; i < maps.length; i++) {
        let gmap = maps[i];
        google.maps.event.addDomListener(window, 'load', function () {
            let map, position;
            let gps = JSON.parse(gmap.dataset.map);

            map = new google.maps.Map(gmap, {
                center: position,
                zoom: 14,
                disableDefaultUI: true,
                draggable: false,
                scrollwheel: false,
            });
            position = new google.maps.LatLng(gps[0], gps[1]);

            var bounds = new google.maps.LatLngBounds();
            bounds.extend(position);
            var marker = new google.maps.Marker({
                position: position,
                map: map,
            });
            map.setCenter(position);
        });
    }
}

$(document).ready(function () {
    if (window.sitekey) {
        renderRecaptcha(window.sitekey);
    }
});

function renderRecaptcha (key) {
    if (key) {
        grecaptcha.ready(function() {
            grecaptcha.execute(key, {action:'validate_captcha'})
                .then(function(token) {
                    // add token value to form
                    document.getElementById('g-recaptcha-response').value = token;
                });
        });
    }
}

/****************************
 *
 * Form validation
 *
 ***************************/

let forms = document.getElementsByClassName('form');

if (forms.length) {
    for (let i = 0; i < forms.length; i++) {
        let form = forms[i];
        let $from = $(form);
        let recaptcha_field = form.querySelector('#g-recaptcha-response');

        let t = new FormValidation($from, {
            inputGroup: 'input-group',
            invalidClass: 'is-invalid',
            loading: '<i class="fa fa-spinner fa-spin mx-auto"></i>',
            button: form.querySelector('button'),
            error: 'X',
            beforeSubmit: () => {
                if (recaptcha_field.value === '') {
                    renderRecaptcha(window.sitekey);
                }
            },
            onSubmitSuccess: (res) => {
                let beforeElement = $from.find('.before-submit');
                let afterElement = $from.find('.after-submit');

                if (res.hasOwnProperty('success')) {
                    beforeElement.hide();
                    afterElement.show();
                }
            },
            onSubmitFailed: (r) => {
                if (r.hasOwnProperty('errors')) {
                    t.showErrors(r.errors);

                    form.querySelector('button').disabled = true;
                    setTimeout(function() {
                        form.querySelector('button').disabled = false;
                    }, 3000);

                    if (r.errors.hasOwnProperty('g-recaptcha-response')) {
                        console.log(r.errors["g-recaptcha-response"]);
                    }
                }

                if (r.hasOwnProperty('errorsbag')) {

                }
            },
        });
    }
}

let searchForm = document.getElementsByClassName('search-form');

if (searchForm.length) {
    let submit = $(searchForm).find('button[type=submit]');
    let search = $(searchForm).find('input[name ="q"]');

    $(submit).on("click", function (e) {
        let parent = $(this).closest('.search');

        if (search.hasClass('hidden')) {
            if (!hasVal()) {
                e.preventDefault();
                search.removeClass('hidden');
                parent.addClass('toggle');
            }
        } else {
            if (!hasVal()) {
                e.preventDefault();
                search.addClass('hidden');
                parent.removeClass('toggle');
            }
        }
    });

    $(search).on("input", function () {
        hasVal();
    });

    function hasVal() {
        if (search.val()) {
            $(submit).prop('disabled', false);
            return true;

        } else {
            return false;
        }
    }
}

/****************************
 *
 * Toggle submenu
 *
 ***************************/
let jsMobileSubmenuTrigger = document.getElementsByClassName('js-mobile-submenu-trigger');
if (jsMobileSubmenuTrigger.length) {
    for (let i = 0; i < jsMobileSubmenuTrigger.length; i++) {
        let menuItem = jsMobileSubmenuTrigger[i];
        let subMenu = $(menuItem).closest('.menu-item').find('.submenu-item');
        menuItem.addEventListener('click', function () {
            if (this.classList.contains('is-triggered')) {
                this.classList.remove('is-triggered');
                subMenu.slideUp();
            } else {
                this.classList.add('is-triggered');
                subMenu.slideDown();
            }
        });
    }
}

// Update menu item align
let lastMenuItem = $('.menu-item--has-submenu:last');

if (lastMenuItem.length) {
    lastMenuItem.addClass('last');
}

